import { Modal } from "react-bootstrap";
import Collapsible from "react-collapsible";
import React, { useState, useEffect, useHistory } from "react";
import "../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { useFormik } from "formik";
import * as Yup from "yup";
const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const basicSchema = Yup.object().shape({
  name: Yup.string().required("Name name is required"),
  email: Yup.string().required("Description  is required"),
  gender: Yup.string().required("Gender  is required"),
  phoneNumber: Yup.string().required("Phone Number  is required"),
  roleId: Yup.string().required("Role  is required"),
  status: Yup.string().required("Status  is required"),
  address: Yup.string().required("Address  is required"),

  profilePicture: Yup.string().nullable("Profile Picture  is required"),
});

const Edit = ({ showModal, hideModal, id, data, getedit }) => {
  const history = useNavigate();
  const onSubmit = async (values, actions) => {
    console.log(values);
    console.log(actions);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    editUser(values);
  };
  const [roles, setRoles] = useState([]);
  const getUsers = async () => {
    const response = await axios
      .get("users/")
      .then((res) => { })
      .catch((err) => {
        notifyError();
      });
  };
  const getRoles = async () => {
    const response = await axios
      .get("/roles", {})
      .then((res) => {
        setRoles(res.data);
      })
      .catch((err) => {
        notifyError();
      });
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit,
    submitForm,
  } = useFormik({
    initialValues: {
      name: data.name,
      email: data.email,
      phoneNumber: data.phoneNumber,
      gender: data.gender,
      profilePicture: data.profilePicture,
      roleId: data.roleId,

      status: data.status,
      address: data.address,
    },
    validationSchema: basicSchema,
    onSubmit,
  });

  const notifySuccess = () =>
    toast.info("User info Updated.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const editUser = async (e) => {
    try {
      const bodyFormData = new FormData();
      bodyFormData.append("id", id);
      for (let value in values) {
        bodyFormData.append(value, values[value]);
      }
      const response = await axios
        .post("/users/" + id, bodyFormData)
        .then((res) => {
          history("/users");
          hideModal();
          getedit();
          getUsers();
          notifySuccess();
        })
        .catch((err) => {
          notifyError();
        });
    } catch (error) {
      notifyError();
    }
  };
  useEffect(() => {
    getRoles();
    getedit();
  }, []);

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete="off"
      encType="multipart/form-data"
    >
      <Modal
        style={{ marginTop: "60px" }}
        show={showModal}
        onHide={hideModal}
        backdrop={false}
        contentClassName="custom-modal-style"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="row">
            <div class="col-md-6">
              <div class="card card-primary">
                <div class="card-body">
                  <div class="form-group">
                    <label for="inputName">Full Name</label>
                    <input
                      type="text"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.name && touched.name
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.name && touched.name && (
                      <p className="error">{errors.name}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="inputName">Email</label>
                    <input
                      type="text"
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.email && touched.email
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.email && touched.email && (
                      <p className="error">{errors.email}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="inputName">Phone</label>
                    <input
                      type="text"
                      name="phoneNumber"
                      value={values.phoneNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.phoneNumber && touched.phoneNumber
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.phoneNumber && touched.phoneNumber && (
                      <p className="error">{errors.phoneNumber}</p>
                    )}
                  </div>
                  <div className="form-group">
                    <label for="inputStatus">Gender</label>
                    <select
                      id="inputStatus"
                      class="form-control custom-select"
                      name="gender"
                      value={values.gender}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.gender && touched.gender
                          ? "form-control input-error"
                          : "form-control "
                      }
                    >
                      <option selected>Select Gender</option>

                      <option value="Male"> Male </option>
                      <option value="Female"> Female </option>
                    </select>
                    {errors.gender && touched.gender && (
                      <p className="error">{errors.gender}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="inputName">Address</label>
                    <input
                      type="text"
                      name="address"
                      value={values.address}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.address && touched.address
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.address && touched.address && (
                      <p className="error">{errors.address}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card card-primary">
                <div class="card-body">
                  <div className="form-group">
                    <label for="inputStatus">Role</label>
                    <select
                      id="inputStatus"
                      class="form-control custom-select"
                      name="roleId"
                      value={values.roleId}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.roleId && touched.roleId
                          ? "form-control input-error"
                          : "form-control "
                      }
                    >
                      <option selected>Select Role</option>
                      {roles.map((role, index) => {
                        return (
                          <option key={role.id} value={role.id}>
                            {role.role_name}
                          </option>
                        );
                      })}
                    </select>
                    {errors.roleId && touched.roleId && (
                      <p className="error">{errors.roleId}</p>
                    )}
                  </div>

                  <div className="form-group">
                    <label for="inputStatus">Status</label>
                    <select
                      id="inputStatus"
                      class="form-control custom-select"
                      name="status"
                      value={values.status}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.status && touched.status
                          ? "form-control input-error"
                          : "form-control "
                      }
                    >
                      <option selected>Select Status</option>

                      <option value="Active"> Active </option>
                      <option value="Inactive"> Inactive </option>
                    </select>
                    {errors.status && touched.status && (
                      <p className="error">{errors.status}</p>
                    )}
                  </div>

                  <div class="form-group">

                    <label for="exampleInputFile">Profile Picture</label>
                    <Collapsible
                      trigger={<i className="fas fa-eye success"> View</i>}
                    >
                      <img
                        className=" img-fluid "
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/uploads/" +
                          values.profilePicture
                        }
                        height="300px"
                        width="300px"
                        alt="profilePicture "
                      />
                    </Collapsible>
                    <div class="input-group">
                      <div class="custom-file">
                        <input
                          type="file"
                          accept="image/*"
                          class="custom-file-input"
                          id="exampleInputFileq"
                          name="profilePicture"
                          onChange={(event) => {
                            setFieldValue(
                              "profilePicture",
                              event.currentTarget.files[0]
                            );
                          }}
                          onBlur={handleBlur}
                          className={
                            errors.profilePicture && touched.profilePicture
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                      </div>
                    </div>
                    {errors.profilePicture && touched.profilePicture && (
                      <p className="error">{errors.profilePicture}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-error" onClick={hideModal}>
            Cancel
          </button>

          <button
            disabled={isSubmitting}
            onClick={submitForm}
            className="btn btn-success"
            type="submit"
          >
            Update
          </button>
        </Modal.Footer>
      </Modal>
    </form>
  );
};

export default Edit;
